import React from 'react';
import { Form, RadioGroup, RadioItem } from 'src/components/Antd';
import SectionWrapper from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/SectionWrapper';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Item = Form.Item;

const AccountDeletion = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { setHasModified, disableEdit, accountDeletable } = props;
  return (
    <SectionWrapper
      title={getI18n('salesChannelRegistration.index.customerAccountDeletion')}
      containerClassName={css.containerClassName}>
      <Item name={'accountDeletable'}>
        <RadioGroup
          className={css.group}
          disabled={disableEdit}
          value={accountDeletable}
          onChange={() => {
            setHasModified(true);
          }}>
          <RadioItem value={true} className={css.radio}>
            {getI18n('salesChannelRegistration.index.allowcustomerdel')}
          </RadioItem>
          <RadioItem value={false} className={css.radio}>
            {getI18n('salesChannelRegistration.index.dontallowcustomerdel')}
          </RadioItem>
        </RadioGroup>
      </Item>
    </SectionWrapper>
  );
};
export default AccountDeletion;
